<template>
    <div>
      <img width="100%" src="../assets/video-img.jpg">
        <answer-header type="back"></answer-header>
        <!-- <img class="logo" src="../assets/logo.png"> -->
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
        <div class="title ac">
          {{videoDetail.title}}
        </div>
    </div>
</template>

<script>
  import VideoPlayer from 'vue-video-player';
  import 'video.js/dist/video-js.css';
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Menu',
    components: {answerHeader},
    data(){
        return {
          videoDetail:{},
          playerOptions: {
            // 这里可以配置 video.js 的选项
            playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
            autoplay: true, // 自动播放
            muted: false, // 静音
            loop: false, // 循环播放
            preload: 'auto', // 预加载
            aspectRatio: '16:9', // 宽高比
            fluid: true, // 自适应容器大小
            sources: [
              {
                type: 'video/mp4', // 视频类型
                src: '' // 视频路径
              }
            ],
            poster: '', // 视频封面
            notSupportedMessage: 'video' // 无法播放时显示的消息
          }
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
      this.getHome()
    },
    methods: {
      onPlayerPlay(player) {
          console.log('视频开始播放', player);
        },
        onPlayerPause(player) {
          console.log('视频暂停', player);
        },
        _goto(target){
            this.$router.push(target);
        },
        getHome(item){
          let that = this
          Utils.$ajax({
              url: '/video/detail/&video_id='+this.$route.query.video_id
          }).done(res=>{
            console.log(res)
              if(res.code != 0){
                  this.$messagebox_lang(res.msg).then();
                  return;
              }else{
                this.videoDetail = res.data
                this.playerOptions.sources[0].src = res.data.video_url
                this.playerOptions.poster = res.data.image_url
                this.playerOptions.notSupportedMessage = res.data.title
              }
          })
        },
        getMore(){
        	let that = this;
        	if(that.isShow){
        		that.page++;
        		that.getHome();
        	}else{
            this.$messagebox_lang('noMore').then(action=>{
            });
        	}
        },
    }
}
</script>

<style lang="scss" scoped>
  .header{left:rem(20) !important}
  .title{font-size:20px;color:#052854;margin-top: 20px;padding: 0 20px;}
  .ac{text-align: center;}
</style>










// WEBPACK FOOTER //
// src/components/video.vue